// extracted by mini-css-extract-plugin
export default {"container":"styles_container__PP98V","center":"styles_center__y-3aV"};